import { NAME } from './constants';

export const RESET = `${NAME}/RESET`;
export const SET_DOCUMENTS = `${NAME}/SET_DOCUMENTS`;
export const PRODUCTION_REPORTED = `${NAME}/PRODUCTION_REPORTED`;
